import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { GlobalVariableService } from "../../../common/variables/global-variable";
import { AgmMap, AgmPolygon } from '@agm/core'
import { TypeAddress } from '../../../common/api/common/TypeAddress';
import { reduce } from 'lodash';

@Component({
  selector: 'sen-app-zone-map',
  templateUrl: './zone-map.component.html',
  styleUrls: ['./zone-map.component.scss']
})
export class ZoneMapComponent implements OnInit {
  @Input() AddLatLon: TypeAddress;
  @Input() zonePathsArray: any;
  @Input() zoneLabels: any;
  @Input() zoneType: any;
  @Input() selectedZone: string;
  @Input() actionType: string;
  @Output() zoneSelected = new EventEmitter<Event>();

  zoneLat: number = 51.00002348765261;
  zoneLon: number = 11.48289599445735;
  markerLat: number;
  markerLon: number;
  selectedZoneFromMap: string;
  showZoneValue: boolean = true;
  zoneColorArray = ["red", "blue", "green", "fuchsia", "aqua"];


  ngOnChanges(changes: SimpleChanges) {
    if (changes.AddLatLon && changes.AddLatLon.currentValue) {
      let latlng = new google.maps.LatLng(changes.AddLatLon.currentValue.lat, changes.AddLatLon.currentValue.lon);
      this.selectedZoneFromMap = '';
      for (let index = 0; index < this.zonePathsArray.length; index++) {
        for (let zone = 0; zone < this.zonePathsArray[index].zonePaths.length; zone++) {
          let polyLatLng = new google.maps.Polygon({ paths: this.zonePathsArray[index].zonePaths[zone] });
          if (google.maps.geometry.poly.containsLocation(latlng, polyLatLng)) {
            this.markerLat = changes.AddLatLon.currentValue.lat;
            this.markerLon = changes.AddLatLon.currentValue.lon;
            this.selectedZoneFromMap = this.zoneLabels[this.zonePathsArray[index].zoneIndex];
            if (this.actionType == this.global.createProject || (this.actionType == this.global.editProject && !changes.AddLatLon.firstChange))
              this.zoneSelected.emit(this.zoneLabels[this.zonePathsArray[index].zoneIndex]);
            break;
          }
        }
        if (this.selectedZoneFromMap) {
          break;
        }
      }
    }

    if (!this.selectedZoneFromMap) {
      this.showZoneValue = false;
      //when user changes the value the popup window will be removed
    } else if (this.selectedZoneFromMap && this.selectedZone && this.selectedZoneFromMap !== this.selectedZone) {
      this.showZoneValue = false;
    } else {
      this.showZoneValue = true;
    }

  }

  constructor(public global: GlobalVariableService) { }

  ngOnInit() {
  }

}
